var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/UserClassifierPriorityOrder.ts";
import { ApiCallService } from '@gmini/api-call-service';
import * as t from 'io-ts';
import { ApiDomain } from '../domain';
export var UserClassifierPriorityOrder;

(function (_UserClassifierPriorityOrder) {
  var domain = ApiDomain.domain('UserClassifierPriorityOrder', {
    name: "domain",
    sid: "-dycqo0"
  });
  var OrderItem = _UserClassifierPriorityOrder.OrderItem = t.type({
    entityId: t.number,
    entityType: t.union([t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily'), t.literal('BimStandardSize'), t.literal('BimElement'), t.literal('UserClassifierGroupWithElements'), t.literal('UserClassifierGroupWithGroups'), t.literal('UserClassifierEmptyGroup'), t.literal('BimModelReference'), t.literal('BimCategoryReference'), t.literal('BimFamilyReference'), t.literal('BimStandardSizeReference'), t.literal('BimElementReference')]),
    priorityOrder: t.number,
    parentRefId: t.union([t.number, t["null"]])
  });
  var Response = _UserClassifierPriorityOrder.Response = t.type({
    classifierId: t.number,
    version: t.number,
    parentId: t.union([t.number, t["null"]]),
    parentType: t.any,
    entityPriorityOrders: t.array(OrderItem),
    type: t.undefined
  });
  var Recalculate;

  (function (_Recalculate) {
    var submit = _Recalculate.submit = ApiCallService.create({
      name: 'UserClassifierPriorityOrder.Recalculate.submit',
      parentDomain: domain,
      result: Response,
      getKey: function getKey() {
        return '0';
      }
    });
  })(Recalculate || (Recalculate = _UserClassifierPriorityOrder.Recalculate || (_UserClassifierPriorityOrder.Recalculate = {})));

  var GetAll;

  (function (_GetAll) {
    var fetch = _GetAll.fetch = ApiCallService.create({
      name: 'UserClassifierPriorityOrder.GetAll.fetch',
      parentDomain: domain,
      result: Response,
      getKey: function getKey() {
        return '0';
      }
    });
  })(GetAll || (GetAll = _UserClassifierPriorityOrder.GetAll || (_UserClassifierPriorityOrder.GetAll = {})));

  var GetOnlyChildren;

  (function (_GetOnlyChildren) {
    var fetch = _GetOnlyChildren.fetch = ApiCallService.create({
      name: 'UserClassifierPriorityOrder.GetOnlyChildren.fetch',
      parentDomain: domain,
      result: Response,
      getKey: function getKey() {
        return '0';
      }
    });
  })(GetOnlyChildren || (GetOnlyChildren = _UserClassifierPriorityOrder.GetOnlyChildren || (_UserClassifierPriorityOrder.GetOnlyChildren = {})));
})(UserClassifierPriorityOrder || (UserClassifierPriorityOrder = {}));